import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ChannelPage from './ChannelPage';
import { getAppChannelDetails } from '../../utils/app';

export class ChannelComponent extends Component {
    static propTypes = {
        appChannels: PropTypes.array.isRequired,
        integrationOrder: PropTypes.array,
        pendingClients: PropTypes.array.isRequired,
        channelStates: PropTypes.object.isRequired,
        visibleChannelCategory: PropTypes.string,
        appUserId: PropTypes.string,
        clients: PropTypes.array,
    };

    render() {
        const {
            appChannels,
            integrationOrder,
            visibleChannelCategory,
            appUserId,
            clients,
            pendingClients,
            channelStates,
        } = this.props;

        const channelPages = getAppChannelDetails(appChannels, integrationOrder).map(({ channel, details }) => {
            const client = clients.find((client) => client.platform === channel.type);
            const pendingClient = pendingClients.find((client) => client.platform === channel.type);

            if (!details.Component || (!!client && !details.renderPageIfLinked)) {
                return null;
            }
            const channelState = channelStates[channel.category];
            const codeToDisplay =
                channelState &&
                ((channelState.linkRequest && channelState.linkRequest.code) || channelState.codeWhileLoading);
            return (
                <ChannelPage
                    key={channel.category}
                    {...details}
                    channel={channel}
                    icon={details.iconLarge}
                    icon2x={details.iconLarge2x}
                    client={client}
                    pendingClient={pendingClient}
                    visible={channel.category === visibleChannelCategory}
                    code={codeToDisplay}
                >
                    <details.Component
                        {...channel}
                        channelState={channelState}
                        getContent={details.getContent}
                        appUserId={appUserId}
                        client={client}
                        linked={!!client}
                        visible={channel.category === visibleChannelCategory}
                    />
                </ChannelPage>
            );
        });

        return <div className="channel-pages-container">{channelPages}</div>;
    }
}

export default connect(
    ({ appState, config, user, integrations }) => {
        return {
            visibleChannelCategory: appState.visibleChannelCategory,
            appChannels: config.integrations,
            integrationOrder: config.integrationOrder,
            channelStates: integrations,
            appUserId: user._id,
            clients: user.clients || [],
            pendingClients: user.pendingClients || [],
        };
    },
    null,
    null,
    { forwardRef: true },
)(ChannelComponent);
